// src/ts/AaveV3Linea.ts
var POOL_ADDRESSES_PROVIDER = "0x89502c3731F69DDC95B65753708A07F8Cd0373F4";
var POOL = "0xc47b8C00b0f69a36fa203Ffeac0334874574a8Ac";
var POOL_CONFIGURATOR = "0x812E7c19421D9f41A6DDCF047d5cc2dE2Ca5Bfa2";
var ORACLE = "0xCFDAdA7DCd2e785cF706BaDBC2B8Af5084d595e9";
var ACL_ADMIN = "0x8c2d95FE7aeB57b86961F3abB296A54f0ADb7F88";
var ACL_MANAGER = "0xbf32c7dFC72b730967072B112927ca0de205dbb5";
var AAVE_PROTOCOL_DATA_PROVIDER = "0x47cd4b507B81cB831669c71c7077f4daF6762FF4";
var POOL_IMPL = "0xeEdB446124322fA833f9A57985E780494bbDe217";
var POOL_CONFIGURATOR_IMPL = "0x6fDdde45f777a4E461B0721a578b169b44579623";
var DEFAULT_INCENTIVES_CONTROLLER = "0xc67bb8F2314fA0df50cBa314c6509A7bdAD500C0";
var EMISSION_MANAGER = "0x0165C65FB21bDC9Cdc09C627d62AB3a983337158";
var COLLECTOR = "0x86E2938daE289763D4e09a7e42c5cCcA62Cf9809";
var DEFAULT_A_TOKEN_IMPL = "0x7b03821ac93Ff55d029A543B86c723aa3Ccb4faC";
var DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = "0xb5E324e16402deA38D8Aed61c472f414d21F2046";
var CONFIG_ENGINE = "0x7e1f23bdFc7287AF276F77B5A867e85cf0377a31";
var RISK_STEWARD = "0xBDF2e1A49894A306Eb76b89504928b3f509A3a16";
var POOL_ADDRESSES_PROVIDER_REGISTRY = "0x96dFCCB3F9ACDaF6c8f8a35E814023C3484d1eA2";
var UI_INCENTIVE_DATA_PROVIDER = "0x117684358D990E42Eb1649E7e8C4691951dc1E71";
var UI_POOL_DATA_PROVIDER = "0x898813Dd328BD3D7353c77aD0B1C0E10F3773E29";
var WALLET_BALANCE_PROVIDER = "0xff75B6da14FfbbfD355Daf7a2731456b3562Ba6D";
var WETH_GATEWAY = "0x31A239f3e39c5D8BA6B201bA81ed584492Ae960F";
var DUST_BIN = "0x94756B7508631509601a5555c93457Bf0ebDbC48";
var CLINIC_STEWARD = "0xA68A0864F304b5145f00A3f8Fd3ec2281568700F";
var POOL_EXPOSURE_STEWARD = "0x07Fc6Fa43Cf6b08d24679ebf8060386b4D41B702";
var STATA_FACTORY = "0xc25Da0Ddab750739d2500dfD4E31EB4E83622F54";
var EDGE_RISK_ORACLE = "0xa6C229d3a1D4D31708B16C0ad2f14337aE4E7893";
var EDGE_RISK_STEWARD_RATES = "0xdDE20B20E21a6F3b7080e740b684CDf5b764B80D";
var EDGE_INJECTOR_RATES = "0x55510C6fD37bcb9398260E49e57b63B31a5E9066";
var CHAIN_ID = 59144;
var ASSETS = {
  WETH: {
    decimals: 18,
    id: 0,
    UNDERLYING: "0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f",
    A_TOKEN: "0x787897dF92703BB3Fc4d9Ee98e15C0b8130Bf163",
    V_TOKEN: "0x0e7543a9dA61b2E71fC880685eD2945B7426a689",
    INTEREST_RATE_STRATEGY: "0xB1532b76D054c9F9E61b25c4d91f69B4133E4671",
    ORACLE: "0x3c6Cd9Cc7c7a4c2Cf5a82734CD249D7D593354dA"
  },
  WBTC: {
    decimals: 8,
    id: 1,
    UNDERLYING: "0x3aAB2285ddcDdaD8edf438C1bAB47e1a9D05a9b4",
    A_TOKEN: "0x37f7E06359F98162615e016d0008023D910bB576",
    V_TOKEN: "0x74A1b56f5137b00AA0ADA1dD964a3A361Ecc32e9",
    INTEREST_RATE_STRATEGY: "0xB1532b76D054c9F9E61b25c4d91f69B4133E4671",
    ORACLE: "0x7A99092816C8BD5ec8ba229e3a6E6Da1E628E1F9"
  },
  USDC: {
    decimals: 6,
    id: 2,
    UNDERLYING: "0x176211869cA2b568f2A7D4EE941E073a821EE1ff",
    A_TOKEN: "0x374D7860c4f2f604De0191298dD393703Cce84f3",
    V_TOKEN: "0x63aB166e6E1b6Fb705b6ca23686FaD9705EB3534",
    INTEREST_RATE_STRATEGY: "0xB1532b76D054c9F9E61b25c4d91f69B4133E4671",
    ORACLE: "0x14ac9f8a8646D11D66fbaA9E9F5A869dC08B5D71",
    STATA_TOKEN: "0xbC3af484919304E005Ca8b735a0d463b876aeB52"
  },
  USDT: {
    decimals: 6,
    id: 3,
    UNDERLYING: "0xA219439258ca9da29E9Cc4cE5596924745e12B93",
    A_TOKEN: "0x88231dfEC71D4FF5c1e466D08C321944A7adC673",
    V_TOKEN: "0x4CEdfa47F7d0e9036110B850Ce49f4cd47b28a2F",
    INTEREST_RATE_STRATEGY: "0xB1532b76D054c9F9E61b25c4d91f69B4133E4671",
    ORACLE: "0x0DccbA847D677d4dc3c22C9Dc17DC468226d08Ed",
    STATA_TOKEN: "0x4D11f27b1c4A5d232a200D2256A4E3d9bAACcF05"
  },
  wstETH: {
    decimals: 18,
    id: 4,
    UNDERLYING: "0xB5beDd42000b71FddE22D3eE8a79Bd49A568fC8F",
    A_TOKEN: "0x58943d20e010d9E34C4511990e232783460d0219",
    V_TOKEN: "0x81C1a619Be23050B3242B41a739e6B6CfDa56687",
    INTEREST_RATE_STRATEGY: "0xB1532b76D054c9F9E61b25c4d91f69B4133E4671",
    ORACLE: "0x96014CA32e2902A5F07c6ADF00eB17D3DE9aC364"
  },
  ezETH: {
    decimals: 18,
    id: 5,
    UNDERLYING: "0x2416092f143378750bb29b79eD961ab195CcEea5",
    A_TOKEN: "0x935EfCBeFc1dF0541aFc3fE145134f8c9a0beB89",
    V_TOKEN: "0x1fE3452CEF885724F8aDF1382ee17d05d7e01CaB",
    INTEREST_RATE_STRATEGY: "0xB1532b76D054c9F9E61b25c4d91f69B4133E4671",
    ORACLE: "0x1217a8A40cea4dB5429fbF6EDeB3B606b99CC9b0"
  },
  weETH: {
    decimals: 18,
    id: 6,
    UNDERLYING: "0x1Bf74C010E6320bab11e2e5A532b5AC15e0b8aA6",
    A_TOKEN: "0x0C7921aB4888fd06731898b3fffFeB06781D5F4F",
    V_TOKEN: "0x37a843725508243952950307CeacE7A9f5D5c280",
    INTEREST_RATE_STRATEGY: "0xB1532b76D054c9F9E61b25c4d91f69B4133E4671",
    ORACLE: "0x0abf2f5642d945b49B8d2DBC6f85c2D8e0424C85"
  },
  wrsETH: {
    decimals: 18,
    id: 7,
    UNDERLYING: "0xD2671165570f41BBB3B0097893300b6EB6101E6C",
    A_TOKEN: "0xCDD80E6211FC767352B198f827200C7e93d7Bb04",
    V_TOKEN: "0xf3C806a402E4E9101373F76C05880EEAc91BB5b9",
    INTEREST_RATE_STRATEGY: "0xB1532b76D054c9F9E61b25c4d91f69B4133E4671",
    ORACLE: "0x444f25c5E73fED92B91F3ECB1bD27003C3CDdeE7"
  },
  mUSD: {
    decimals: 6,
    id: 8,
    UNDERLYING: "0xacA92E438df0B2401fF60dA7E4337B687a2435DA",
    A_TOKEN: "0x61B19879F4033c2b5682a969cccC9141e022823c",
    V_TOKEN: "0x8619B395Fd96DCFe3f2711d8BF84b26338db0294",
    INTEREST_RATE_STRATEGY: "0xB1532b76D054c9F9E61b25c4d91f69B4133E4671",
    ORACLE: "0xA77b1C51a76bbB72D17BF467393a540868103097"
  }
};
var E_MODES = {
  "1": {
    label: "wstETH / WETH",
    collateralBitmap: "16",
    collateralAssets: ["0xB5beDd42000b71FddE22D3eE8a79Bd49A568fC8F"],
    borrowableBitmap: "1",
    borrowableAssets: ["0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f"],
    ltvzeroBitmap: "0",
    ltvzeroAssets: [],
    ltv: 9350,
    liquidationThreshold: 9550,
    liquidationBonus: 10100
  },
  "2": {
    label: "ezETH / WETH",
    collateralBitmap: "32",
    collateralAssets: ["0x2416092f143378750bb29b79eD961ab195CcEea5"],
    borrowableBitmap: "1",
    borrowableAssets: ["0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f"],
    ltvzeroBitmap: "0",
    ltvzeroAssets: [],
    ltv: 9e3,
    liquidationThreshold: 9300,
    liquidationBonus: 10100
  },
  "3": {
    label: "weETH / WETH",
    collateralBitmap: "64",
    collateralAssets: ["0x1Bf74C010E6320bab11e2e5A532b5AC15e0b8aA6"],
    borrowableBitmap: "1",
    borrowableAssets: ["0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f"],
    ltvzeroBitmap: "0",
    ltvzeroAssets: [],
    ltv: 9e3,
    liquidationThreshold: 9300,
    liquidationBonus: 10100
  },
  "4": {
    label: "wrsETH / WETH",
    collateralBitmap: "128",
    collateralAssets: ["0xD2671165570f41BBB3B0097893300b6EB6101E6C"],
    borrowableBitmap: "1",
    borrowableAssets: ["0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f"],
    ltvzeroBitmap: "0",
    ltvzeroAssets: [],
    ltv: 9e3,
    liquidationThreshold: 9300,
    liquidationBonus: 10100
  }
};
var EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: "0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC",
  BORROW_LOGIC: "0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635",
  LIQUIDATION_LOGIC: "0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104",
  POOL_LOGIC: "0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5",
  SUPPLY_LOGIC: "0x33654b16A4De97bCE05d7dD06803Bf1066f3123C"
};
export {
  AAVE_PROTOCOL_DATA_PROVIDER,
  ACL_ADMIN,
  ACL_MANAGER,
  ASSETS,
  CHAIN_ID,
  CLINIC_STEWARD,
  COLLECTOR,
  CONFIG_ENGINE,
  DEFAULT_A_TOKEN_IMPL,
  DEFAULT_INCENTIVES_CONTROLLER,
  DEFAULT_VARIABLE_DEBT_TOKEN_IMPL,
  DUST_BIN,
  EDGE_INJECTOR_RATES,
  EDGE_RISK_ORACLE,
  EDGE_RISK_STEWARD_RATES,
  EMISSION_MANAGER,
  EXTERNAL_LIBRARIES,
  E_MODES,
  ORACLE,
  POOL,
  POOL_ADDRESSES_PROVIDER,
  POOL_ADDRESSES_PROVIDER_REGISTRY,
  POOL_CONFIGURATOR,
  POOL_CONFIGURATOR_IMPL,
  POOL_EXPOSURE_STEWARD,
  POOL_IMPL,
  RISK_STEWARD,
  STATA_FACTORY,
  UI_INCENTIVE_DATA_PROVIDER,
  UI_POOL_DATA_PROVIDER,
  WALLET_BALANCE_PROVIDER,
  WETH_GATEWAY
};
//# sourceMappingURL=AaveV3Linea.mjs.map